export const DeviationArticleStatus = {
	ADD: 0,
	IGNORE: 1,
	CONFLICT: 2,
	RESOLVED: 3,
};